import React from 'react';
import { Fragment } from 'react';
import FaqPanel from '../TorontoFleets/Shared/FaqPanel';
import CategoryContainer from './CategoryContainer';
import SearchResults from './SearchResults';
import SubCategoryContainer from './SubCategoryContainer';
import _ from 'lodash';

const FaqDropdownContent = ({
  searchVal,
  isSearch,
  noResult,
  categoryDisplayed,
  selected,
  category,
  FaqGeneral,
  FaqContact,
  FaqEligibility,
  FaqEv,
  FaqReferral,
  FaqSignup,
  FaqSafety,
  closeSearch,
  setInput,
  searchResult,
  setSearchResult,
  handleSelected,
  setCategory,
  setSearchVal
}) => {
  const allFaq = _.concat(
    FaqGeneral,
    FaqEv,
    FaqEligibility,
    FaqReferral,
    FaqSignup,
    FaqSafety,
    FaqContact
  );

  return (
    <Fragment>
      <SearchResults
        searchResult={searchResult}
        searchVal={searchVal}
        noResult={noResult}
        isSearch={isSearch}
      />
      {categoryDisplayed.map(
        cat =>
          !searchVal &&
          !isSearch && (
            <Fragment>
              <CategoryContainer
                selected={selected}
                category={category}
                cat={cat}
                handleSelected={handleSelected}
                setCategory={setCategory}
              />
              <SubCategoryContainer
                searchVal={searchVal}
                isSearch={isSearch}
                selected={selected}
                cat={cat}
                category={category}
                FaqGeneral={FaqGeneral}
                FaqContact={FaqContact}
                FaqEligibility={FaqEligibility}
                FaqEv={FaqEv}
                FaqReferral={FaqReferral}
                FaqSignup={FaqSignup}
                FaqSafety={FaqSafety}
              />
            </Fragment>
          )
      )}
      {isSearch && searchVal && !noResult && (
        <div className="expanded-faq-general-container">
          <FaqPanel
            faq={allFaq}
            isSearch={isSearch}
            searchVal={searchVal}
          />
        </div>
      )}
      {searchVal && (
        <button
          className={'backtofaq-button'}
          onClick={() => {
            closeSearch();
            setInput('');
            setSearchVal('');
            setSearchResult(false);
            window.location.reload();
          }}>
          Back to FAQ
        </button>
      )}
    </Fragment>
  );
};

export default FaqDropdownContent;



// WEBPACK FOOTER //
// ./src/components/Static/NewGeneralFaq/FaqDropdownContent.js